import * as React from 'react';
import {Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHardDrive} from "@fortawesome/free-solid-svg-icons";
import {Link, useLocation} from "react-router-dom";
import {SystemRoutes} from "../../../../Utils/RouteUtils";
import { useAppSelector } from '../../../../Config/Hooks';
import { hasPermission } from '../../../Auth/AuthenticationUtil';
import { AUTHORITIES } from '../../../../Config/Constants';

const style = {
    linkItem: {
        textDecoration: "none",
        color: "inherit"
    },
};

export default function SGDSettingsMenu() {
    const location = useLocation();
    const theme = useTheme();
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToUsers = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_USERS
    ]);
    const isAuthorizedToSearchProfile = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_PROFILE
    ]);
    const isAuthorizedToSearchAlarmSeverity = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_ALARM_SEVERITY
    ]);
    const isAuthorizedToSearchGeneric = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS
    ]);
    const isAuthorizedToSearchBroker = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_BROKER
    ]);
    const isAuthorizedToSearchEquipment = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_EQUIPMENT
    ]);
    const isAuthorizedToSearchEquipmentClass = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_EQUIPMENT_CLASS
    ]);
    const isAuthorizedToSearchEquipmentType = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_EQUIPMENT_TYPE
    ]);
    const isAuthorizedToSearchGraphElement = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_GRAPH_ELEMENT
    ]);
    const isAuthorizedToSearchPowerStationExcel = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_POWER_STATION_EXCEL
    ]);
    const isAuthorizedToSearchTeleObject = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_TELE_OBJECT
    ]);
    const isAuthorizedToSearchPowerPlant = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_POWER_PLANT
    ]);
    const isAuthorizedToSearchPowerStationUser = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_POWER_STATION_USER
    ]);
    const isAuthorizedToSearchTicketCategory = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_TICKET_CATEGORY
    ]);
    const isAuthorizedToSearchTicketSubCategory = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SEARCH_SETTINGS, AUTHORITIES.SEARCH_TICKET_SUBCATEGORY
    ]);


    return (
        <Box sx={{ width: '100%', maxWidth: 360, ml: '2%',
            bgcolor: theme.palette.mode === 'light' ? 'background.paper' : '#1E1E1E',
            height: '100%',
            overflowY: 'auto',
            borderBottomLeftRadius: '16px',
            borderBottomRightRadius: '16px',
        mt: 1}}>
            <nav aria-label="main mailbox folders">
                <List>
                    <Link style={style.linkItem} to={isAuthorizedToSearchAlarmSeverity ? SystemRoutes.SETTINGS_ALARM_SEVERITY : "#"}>
                        <ListItem disablePadding selected={location.pathname.includes("alarm-severity")}>
                            <ListItemButton disabled={!isAuthorizedToSearchAlarmSeverity}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Severidade do Alarme" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={isAuthorizedToSearchGeneric ? SystemRoutes.SETTINGS_STATUS_COLOR : "#"}>
                        <ListItem disablePadding selected={location.pathname.includes("status")} >
                            <ListItemButton disabled={!isAuthorizedToSearchGeneric}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary={"Status"} />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={isAuthorizedToSearchBroker ? SystemRoutes.SETTINGS_BROKER : "#" }>
                        <ListItem disablePadding selected={location.pathname.includes("broker")}>
                            <ListItemButton  disabled={!isAuthorizedToSearchBroker}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Broker" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchEquipment ? SystemRoutes.SETTINGS_EQUIPMENT : "#"}>
                        <ListItem disablePadding selected={location.pathname.includes("equipment") && !location.pathname.includes("class") && !location.pathname.includes("type")}>
                            <ListItemButton disabled={!isAuthorizedToSearchEquipment}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Equipamento" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchEquipmentClass ? SystemRoutes.SETTINGS_EQUIPMENT_CLASS : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("equipment-class")}>
                            <ListItemButton disabled={!isAuthorizedToSearchEquipmentClass}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Classe de Equipamento" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchEquipmentType ? SystemRoutes.SETTINGS_EQUIPMENT_TYPE : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("equipment-type")}>
                            <ListItemButton disabled={!isAuthorizedToSearchEquipmentType}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Tipo de Equipamento" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchGraphElement ? SystemRoutes.SETTINGS_GRAPH_ELEMENT : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("graph-element")}>
                            <ListItemButton disabled={!isAuthorizedToSearchGraphElement}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Mapa de Elementos Gráficos" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchPowerStationExcel ? SystemRoutes.SETTINGS_POWER_STATION_EXCEL : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("power-station-excel")}>
                            <ListItemButton disabled={!isAuthorizedToSearchPowerStationExcel}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Usina via Excel" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={isAuthorizedToSearchTeleObject ? SystemRoutes.SETTINGS_TELE_OBJECT : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("tele-object") && !location.pathname.includes("specification") && !location.pathname.includes("type")}>
                            <ListItemButton disabled={!isAuthorizedToSearchTeleObject}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Teleobjeto" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchPowerPlant ? SystemRoutes.SETTINGS_POWER_PLANT : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("power-plant")}>
                            <ListItemButton disabled={!isAuthorizedToSearchPowerPlant}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Usina" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchPowerStationUser ? SystemRoutes.SETTINGS_POWER_STATION_USER : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("power-station-user")}>
                            <ListItemButton disabled={!isAuthorizedToSearchPowerStationUser}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Acesso de Usuário a Usina" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={isAuthorizedToSearchGeneric ? SystemRoutes.SETTINGS_NOTIFICATION_GROUP : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("notification-group")}>
                            <ListItemButton disabled={!isAuthorizedToSearchGeneric}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Notificações" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchProfile ? SystemRoutes.SETTINGS_PROFILE : "#"}>
                        <ListItem disablePadding selected={location.pathname.includes("profiles")}>
                            <ListItemButton disabled={!isAuthorizedToSearchProfile}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Permissões" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={isAuthorizedToUsers ? SystemRoutes.SETTINGS_USERS : "#"}>
                        <ListItem disablePadding selected={location.pathname.includes("users")}>
                            <ListItemButton disabled={!isAuthorizedToUsers}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Usuários" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchTicketCategory ? SystemRoutes.SETTINGS_TICKET_CATEGORY : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("ticket-category")}>
                            <ListItemButton disabled={!isAuthorizedToSearchTicketCategory}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Ticket Categoria" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                    <Link style={style.linkItem} to={ isAuthorizedToSearchTicketSubCategory ? SystemRoutes.SETTINGS_TICKET_SUBCATEGORY : '#'}>
                        <ListItem disablePadding selected={location.pathname.includes("ticket-subcategory")}>
                            <ListItemButton disabled={!isAuthorizedToSearchTicketSubCategory}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faHardDrive} />
                                </ListItemIcon>
                                <ListItemText primary="Ticket SubCategoria" />
                            </ListItemButton>
                        </ListItem>
                    </Link>
                </List>
            </nav>
        </Box>

    );
}
